var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_348_2083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_348_2083",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_348_2083",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_348_2083",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEnklEQVR4nO2dy24cVRCGj5RwU7hsISABAl6AywoQCAFbYAFI3MR9EyRzETFLdgFWkSVeIwRYBMEDgJARmGzYABvCyIw9Pf3/3QZLjguVcoLCyBNN4nO6Ts/UJ5VkeTwz1b9ruuvU1KkOwXEcx3Ecx3Ecx5kNETnQtu19AF4j+QnJkwB+JvkryRGAbTX9WX8XHztJ8mN9Ttu29+przPh2i0XbtreQfJvklyRrkrJPG5P8guRS27Y3h0VGRK5pmuZFAN8AOJtA3D0NwA6Ar0m+ICJXh0VhfX39Wo00AGdyiXsR+4vkh6PR6IYwr4jIFXVdv09y00DgSVMf3lOfwjwB4EEApwsQeNJ+Iflo6Dt6TiT5KYDdAkTd09Q3ACsiclXoI1VV3UbyO2shObvgP4zH4ztDn9CPY6I0TTo2TQsfCX0AwFMA/i5ANLnMyNbF0LOhZAC8mTMnZndinwXwRigRAE/q4sBaJCYUm+QzoST0vAbgH2txmF7s7aZpHg8lUNf1XT298MmMNh6Px3eYiqy5p6ZFBYghmSN71TTP1sWItQjsTuwVy2X17gIJvQvgoU5FFpGDANasD57di32600JUrMJ1fZDb+r5N09ykBuBoXFx0Lfg7nYg8HA6vsyh1Ajg66QuAZQOhh1pTzy600cGJRvGkL03T3Gjhi9ays5c9AfxpcXBhCha+ABjoV3HZhG6a5iWjCJKShI72XDah9YtUF5rno/pUFpH1a3vLolGYgmXRKUsrQ+y7sPqYSmlCR3srh9Da3OJC838anEgqsrZYkaxcaE4GWpW0/Ux74Yw/ojLNN2u/2ra9J5nQAF63PqBQqNB1Xb+STOjY1elCc08NjqUU+nMXmvkviCWURMP0IDD1C8CPyYQm+XvqUmcwIkOJ9bdkzpHcyFXqtCJhFXKY0qkk//3GMJJzlVi1zaI4odu2PRwKQesUxQmd8NSxHAoBwAfFnTpSXgwBLFtGtr63+lDkxdDTO3aW3vmChR0sWHwJzm6W4HEXq1hamB4Epn7Vdf1yMqG9TMqpQjdNc3cyob3wz24K/0rcW+2nDma6EF4g9JILzclAO5Ir0fd2A/6XP+9ovSTkIE4J8KyDGRtoFB374EIzf0tYbHI8s+h5NHI3OVo1oXNKiTVVqfMy7N0wx43oyxlLnZdiw8FgcCh0gTZiGwi9fb7EmqHUeSm2FDreLPSTwUHKQm0WUgA84NvfOkI3OS5QNB8PxluUVxdA5O9F5MpgiW5Ij5NbZE6tqqrq9lACJB/u89QZTo9kzWoeCyUB4Ik5HIzydCgRHY8zJ6N+drQnPJRMHPnT29MIzk3SKWvEz8VG//T0Alnp9Sb0ia2trVtJftujSF41H+mzzzx7peQVZBx4ctw8T064XF8rUOQ1APeHeUJEDupQES0zWgscfVhSn8K8MhgMDsVB3X8YRPC6Dure2Ni4PiwKcm7k8fMAvsq50Ik58Sn9jm+hRs/vhW650A3sJD+Ld6PYr8Cj+FpHsrUE9B0ROaD9bHVdv0ryI+0G0h7keHuQzQtuD7IZbw+ij53Qv9VdrPpcvz2I4ziO4ziO4zhOmJ1/AUUFCfW6kgV5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusImage);
export default __webpack_public_path__ + "static/media/plus-image.06f199ebe836a74b6b279576f960b6fd.svg";
export { ForwardRef as ReactComponent };